import service from '@/store/services/workshop/client_master-service';

const state = {
  list: {},
  client_master: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, client_master) => {
    state.client_master = client_master;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((client_master) => { commit('SET_RESOURCE', client_master); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((client_master) => { commit('SET_RESOURCE', client_master); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((client_master) => { commit('SET_RESOURCE', client_master); });
  },

  find_phone({commit, dispatch}, params) {
    return service.find_phone(params)
      .then((client_master) => { commit('SET_RESOURCE', client_master); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((client_master) => { commit('SET_RESOURCE', client_master); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  client_master: state => state.client_master,
  page: state => state.meta.page,
};
 
const client_master = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default client_master;
